



























module.exports =
  props: ['event']

  data: ->
    current_user: Session.current_user
    element_id: @event.task.id
    undone_at: null
    tooltip_text: @event.task.comment

  computed:
    icon_class: ->
      switch @event.task.service.split('::')[1]
        when 'Phonecall' then 'task-icon phonecall-task-icon'
        when 'Email' then 'task-icon email-task-icon'
        when 'Linkedin' then 'task-icon linkedin-task-icon'
        when 'Meeting' then 'calendar-task-icon'

    enable_undo: ->
      !@undone_at && @event.task.canBeUndone() && @user_can_manage

    user_can_manage: ->
      return false if @current_user.isSeller() && @current_user.id != @event.task.assigned_to_id
      !@current_user.isMonitoringManager()

  methods:
    undo: ->
      @tasks_resources.save @undoSuccess, @unknownError, { id: @event.task.id, done_at: null }

    undoSuccess: (data) ->
      alertify.success 'Tarefa atualizada com sucesso'
      @event.task.done_at = null
      @undone_at = moment()
      task = new Task(data.task)
      task.contact = data.task.contact
      EventsBus.$emit 'Task::EventUndone', task

  watch:
    task: (new_value, old_value) ->
      @$refs.element_id.setAttribute('data-original-title', new_value.comment)

  mounted: ->
    Tooltip.initialize()

  created: ->
    @tasks_resources = new TasksResource()
    @undone_at = moment(@event.description) if @event.description




// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/events/manual_task_event.vue